import React, { useState } from 'react';
import axios from 'axios';

const sectionStyle = {
  maxWidth: "800px",
  margin: "0 auto",
  padding: "60px 20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "30px",
  background: "#fff",
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "6px",
  border: "1px solid #ddd",
  marginTop: "6px",
  fontSize: "14px"
};

const labelStyle = {
  fontWeight: "500",
  display: "block",
  marginBottom: "4px"
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [successMessage, setSuccessMessage] = useState(null);
  const [showForm, setShowForm] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        'https://3kf80u96ve.execute-api.eu-central-1.amazonaws.com/prod/v1/messages',
        formData,
        {
          headers: {
            'Content-Type': 'text/plain'
          }
        }
      );

      setSuccessMessage("Thanks! Your message has been sent. I’ll get back to you shortly.");
      setShowForm(false);

    } catch (error) {
      console.error('Error sending form data:', error);
    }
  };

  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px", textAlign: "center" }}>
        <h1 style={{ fontSize: "40px", marginBottom: "16px" }}>
          Let’s discuss your project
        </h1>

        <p style={{
          color: "#555",
          fontSize: "18px",
          maxWidth: "600px",
          margin: "0 auto"
        }}>
          Tell me about your idea, system, or challenge. I’ll help you design and build the right solution.
        </p>
      </div>


      {/* FORM */}
      {showForm && (
        <div style={sectionStyle}>
          <div style={cardStyle}>
            <form onSubmit={handleSubmit}>

              {/* NAME */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                  style={inputStyle}
                />
              </div>

              {/* EMAIL */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  required
                  style={inputStyle}
                />
              </div>

              {/* SUBJECT */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Project, consultation, optimization..."
                  required
                  style={inputStyle}
                />
              </div>

              {/* MESSAGE */}
              <div style={{ marginBottom: "25px" }}>
                <label style={labelStyle}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Describe your project or challenge..."
                  required
                  rows={5}
                  style={inputStyle}
                />
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "16px",
                  background: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
                }}
              >
                Send Message
              </button>

            </form>
          </div>
        </div>
      )}


      {/* SUCCESS STATE */}
      {!showForm && (
        <div style={{ ...sectionStyle, textAlign: "center" }}>
          <h2 style={{ marginBottom: "20px" }}>
            Message Sent
          </h2>

          <p style={{ color: "#555" }}>
            {successMessage}
          </p>

          <a href="/" style={{
            display: "inline-block",
            marginTop: "20px",
            color: "#007bff"
          }}>
            Back to Home →
          </a>
        </div>
      )}

    </div>
  );
};

export default Contact;